import { useEffect, useState } from 'react';
import { get } from 'lodash';

async function authWithKey(client, key) {
  const query = `
    mutation($key: String!) {
      auth: authGroupAnonymous(input: {
        tmpKey: $key
      }) {
        token: jwt
      }
    }
  `;
  const result = await client.request(query, { key });
  return get(result, 'auth.token');
}

export default function useAuth({ client, key }) {
  const [token, setToken] = useState(null);
  useEffect(() => {
    if (client && key) {
      authWithKey(client, key).then(setToken).catch(console.error);
    }
  }, [client, key]);
  return {
    token,
  };
}
